import * as types from './types';
import {
  ToolBookStatementCollegeListModel,//结算学院列表
  ToolBookStatementCollegeBookStatementModel,//学院结算详情
  ToolBookStatementCollegeBookStatementDeleteModel,//删除学院结算列表
  ToolBookStatementBookStatementIdCollegeCreateModel,//创建结算学院列表
  ToolBookStatementBookStatementIdCollegeAdvancePaymentModel,//设置预付款
} from 'src/model/index'
import {
  extend,
  findIndex
} from 'lodash';

export default{
  // 学院结算详情
  actionGetToolBookStatementCollegeBookStatement({commit, state}, query){
    if (state.toolBookStatementCollegeBookStatementDetail.state === 'loading') {
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_NOOK_STATEMENT_COLLEGE_BOOK_STATEMENT, {
      state: 'loading'
    });
    return ToolBookStatementCollegeBookStatementModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_TOOL_NOOK_STATEMENT_COLLEGE_BOOK_STATEMENT, {
        ...response,
        state: 'loadend',
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_TOOL_NOOK_STATEMENT_COLLEGE_BOOK_STATEMENT, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },
  //获取结算学院列表
  actionGetListOfClearingSchoolsPort({state,commit},query){
    commit(types.ACTION_GET_LIST_OF_CLEARING_SCHOOL_PORT,{
      state:'loading'
    });
    return ToolBookStatementCollegeListModel.getInstance().execute(query).then(function (response) {
      commit(types.ACTION_GET_LIST_OF_CLEARING_SCHOOL_PORT,{
        state:'loadend',
        list:response.list,
        total:response.total,
      });
      return response
    }).catch(function (err) {
      commit(types.ACTION_GET_LIST_OF_CLEARING_SCHOOL_PORT,{
        state:'loaderr'
      });
      return Promise.reject(err)
    });
  },
  //删除学院结算列表
  actionDeleteCloseAnAccountList({state},query){
    return ToolBookStatementCollegeBookStatementDeleteModel.getInstance().execute(query);
  },

  //创建学院结算列表
  actionEstablishCloseAnAccountList({state},query){
    return ToolBookStatementBookStatementIdCollegeCreateModel.getInstance().execute(query);
  },

  //设置预付款
  actionSettleAccountsCollegeSetUpAdvancePort({state},query){
    return ToolBookStatementBookStatementIdCollegeAdvancePaymentModel.getInstance().execute(query);
  },


}





// WEBPACK FOOTER //
// ./src/store/Admin/modules/listOfClearingSchools/actions.js